/**
 * BCP-47 locale для Intl-форматирования дат/чисел по активному языку UI.
 *
 * Раньше маппинг был захардкожен inline в нескольких файлах как "ru-RU" →
 * русские месяцы/дни недели ("22 июля", "пн") на EN/DE/UK-локалях. Тот же
 * маппинг уже жил inline в AnalyticsPage/AthletePlanPage/PathAndGoalPage —
 * здесь он вынесен для переиспользования новыми call-site'ами.
 *
 * Принимает i18n.language (может быть "de-DE", "ru", "uk" и т.п.) — берём
 * первые 2 символа и мапим на полный BCP-47 tag.
 */
export function localeFor(lang?: string): string {
  const l = (lang ?? "ru").slice(0, 2);
  return l === "uk"
    ? "uk-UA"
    : l === "de"
      ? "de-DE"
      : l === "en"
        ? "en-GB"
        : "ru-RU";
}
